<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="d-flex">
      <div class="item-title">发货方：</div>
      <div style="width:200px;">
        <span class="item-text">{{ formData.pickupPoint.orderPointName }}</span>
      </div>
      <div class="item-title">发货城市：</div>
      <div style="width:220px;">
        <span class="item-text">{{ showPickupPoint }}</span>
      </div>
      <div class="item-title">发货地址：</div>
      <div style="width:350px;">
        <span class="item-text">{{
          formData.pickupPoint.linePointAddress
        }}</span>
      </div>
      <div class="item-title">是否装货：</div>
      <div class="item-text">
        <span>{{
          formData.pickupPoint.orderPickType === 'Z' ? '是' : '否'
        }}</span>
      </div>
    </div>
    <div class="d-flex">
      <div class="item-title">收货方：</div>
      <div style="width:200px;">
        <span class="item-text">{{
          formData.receivingPoint.orderPointName
        }}</span>
      </div>
      <div class="item-title">收货城市：</div>
      <div style="width:220px;">
        <span class="item-text">{{ showReceivePoint }}</span>
      </div>
      <div class="item-title">收货地址：</div>
      <div style="width:350px;">
        <span class="item-text">{{
          formData.receivingPoint.linePointAddress
        }}</span>
      </div>
      <div class="item-title">是否卸货：</div>
      <div class="item-text">
        <span>{{
          formData.receivingPoint.orderPickType === 'X' ? '是' : '否'
        }}</span>
      </div>
    </div>
    <div class="d-flex mt-2">
      <div class="item-title">订单类型：</div>
      <div class="item-text">
        <span>{{ formData.orderTypeName }}</span>
      </div>
      <div class="item-title">业务类型：</div>
      <div class="item-text">
        <span>{{ formData.bizTypeName }}</span>
      </div>
      <div class="item-title">运输模式：</div>
      <div class="item-text">
        <span>{{ formData.transportModeName }}</span>
      </div>
      <div class="item-title">车型需求：</div>
      <div class="item-text">
        <span>{{
          formData.vehicleModelName ? formData.vehicleModelName : '不限'
        }}</span>
      </div>
      <div class="item-title">车长需求：</div>
      <div class="item-text">
        <span>{{
          formData.vehicleLengthName ? formData.vehicleLengthName : '不限'
        }}</span>
      </div>
      <div class="item-title">是否返程：</div>
      <div class="item-text">
        <span>{{ formData.isBack ? '是' : '否' }}</span>
      </div>
    </div>
    <div class="d-flex">
      <div class="item-title">载重需求：</div>
      <div class="item-text">
        <span>{{ formData.vehicleLoad ? formData.vehicleLoad : '不限' }}</span>
      </div>
      <div class="item-title">载方需求：</div>
      <div class="item-text">
        <span>{{
          formData.vehicleVolume ? formData.vehicleVolume : '不限'
        }}</span>
      </div>
      <div class="item-title">总件数：</div>
      <div class="item-text">
        <span>{{ formData.totQty }} 件</span>
      </div>
      <div class="item-title">总重量：</div>
      <div class="item-text">
        <span>{{ formData.totInWeight }} kg</span>
      </div>
      <div class="item-title">总体积：</div>
      <div class="item-text">
        <span>{{ formData.totInVolume }} m³</span>
      </div>
      <div class="item-title">总货值：</div>
      <div class="item-text">
        <span>{{ formData.totValue }}</span>
      </div>
    </div>

    <div class="mt-3">
      <vxe-grid
        ref="table"
        highlight-hover-row
        :loading="loading"
        :data="tableData"
        :height="tableHeight"
        :columns="tableColumns"
        :radio-config="{ trigger: 'cell', highlight: true }"
        row-key
        size="small"
        resizable
        border
        empty-text="没有匹配到符合条件的有效合同"
        @radio-change="radioChangeEvent"
      >
        <template v-slot:toolbar_form>
          <slot name="header"> </slot>
        </template>
        <template v-slot:contractFee="{ row }">
          <div>
            <el-link type="primary" @click="showFeeDetail(row)">{{
              row.contractFee
            }}</el-link>
          </div>
        </template>
        <template v-slot:pickupPointText="{ row }">
          <span>
            {{
              row.pickupPointText +
                '  ' +
                (formData.pickupPoint.orderPointName
                  ? formData.pickupPoint.orderPointName
                  : '')
            }}
          </span>
        </template>
        <template v-slot:receivingPointText="{ row }">
          <span>
            {{
              row.receivingPointText +
                '  ' +
                (formData.receivingPoint.orderPointName
                  ? formData.receivingPoint.orderPointName
                  : '')
            }}
          </span>
        </template>
        <template v-slot:contractName="{ row }">
          <div>
            <span style="color:#F56C6C;" v-if="row.contractSetError === 'Y'"
              >(报价设置异常)</span
            >
            {{ row.contractName }}
          </div>
        </template>
      </vxe-grid>
    </div>
    <el-form
      ref="incomeData"
      :model="incomeData"
      label-position="left"
      label-width="100px"
    >
      <el-row :gutter="10" class="mt-3">
        <el-col :span="12">
          <el-form-item label="合同" size="small">
            <el-input
              placeholder="请选择合同"
              v-model="incomeData.contractName"
              readonly
              :disabled="disabled"
            >
              <!-- <el-button
                slot="append"
                icon="el-icon-delete"
                @click="clear()"
                :disabled="disabled"
              ></el-button> -->
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收入总价" size="small">
            <el-input-number
              v-model="totAmount"
              style="width:100%"
              :min="0"
              :controls="false"
              :precision="4"
              size="small"
              disabled
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="合同收入总价" size="small">
            <el-input-number
              v-model="incomeData.contractAmount"
              style="width:100%"
              :min="0"
              :controls="false"
              :precision="4"
              size="small"
              disabled
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="计价方式" size="small">
            <dict-select
              clearable
              v-model="incomeData.chargeUnit"
              placeholder="请选择计价方式"
              default
              filterable
              size="small"
              style="width:100%"
              :body="selectChargeUnit"
              :disabled="disabled"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="单价" size="small">
            <el-input-number
              v-model="basePrice"
              style="width:100%"
              :min="0"
              :controls="false"
              :precision="4"
              size="small"
              :disabled="disabled"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运费" size="small">
            <el-input-number
              v-model="orderFreight"
              style="width:100%"
              :min="0"
              :controls="false"
              :precision="4"
              size="small"
              :disabled="disabled"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="其他费用" size="small">
            <el-input-number
              v-model="orderFee"
              style="width:100%"
              :min="0"
              :controls="false"
              :precision="4"
              size="small"
              disabled
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="备注" size="small">
            <el-input
              v-model="incomeData.remark"
              size="small"
              :disabled="disabled"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <ExpenseDetails
      ref="expenseDetails"
      :data="data"
      :orderFee.sync="orderFee"
    />

    <div class="dialog-footer mt-3 d-flex justify-content-end">
      <el-button @click="choiceClose()" size="small">
        取消
      </el-button>
      <el-button type="primary" @click="choiceOk()" size="small"
        >确认选择</el-button
      >
    </div>
  </div>
</template>
<script>
import ExpenseDetails from './expenseDetails.vue'
import { add } from '@/libs/util.number.js'
export default {
  components: {
    ExpenseDetails,
  },
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fullScreenLoading: false,
      loading: false,
      tableData: [],
      tableHeight: 200,
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          title: '选择',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'radio',
        },
        {
          title: '合同编号',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          width: '140',
          field: 'contractNo',
        },
        {
          title: '合同名称',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'left',
          minWidth: '140',
          field: 'contractName',
          slots: {
            default: 'contractName',
          },
        },
        {
          title: '始发地',
          showHeaderOverflow: 'title',
          showOverflow: 'tooltip',
          headerAlign: 'center',
          align: 'left',
          width: '200',
          field: 'pickupPointText',
          slots: {
            default: 'pickupPointText',
          },
        },
        {
          title: '目的地',
          showHeaderOverflow: 'title',
          showOverflow: 'tooltip',
          headerAlign: 'center',
          align: 'left',
          width: '200',
          field: 'receivingPointText',
          slots: {
            default: 'receivingPointText',
          },
        },
        {
          title: '运费',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'contractFreight',
        },
        {
          title: '附加费',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'contractFee',
          slots: {
            default: 'contractFee',
          },
        },
        {
          title: '合同总价',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '80',
          field: 'contractAmount',
        },
        {
          title: '计费方式',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '75',
          field: 'chargeUnitName',
        },
        {
          title: '车型',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '75',
          field: 'vehicleModelName',
        },
        {
          title: '车长',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '75',
          field: 'vehicleLengthName',
        },
        {
          title: '载重',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '75',
          field: 'vehicleLoad',
        },
        {
          title: '载方',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          align: 'center',
          width: '75',
          field: 'vehicleVolume',
        },
      ],
      data: [],
      selectChargeUnit: { type: 'chargeUnit' },
      orderFreight: 0,
      basePrice: 0,
      orderFee: 0,
      incomeData: {},
      oldTableDataIndex: null,
    }
  },
  watch: {
    formData: {
      handler(formData) {
        if (formData) {
          this.load()
        }
      },
      immediate: true,
    },
  },
  computed: {
    showPickupPoint: {
      get() {
        let temp =
          this.formData.pickupPoint.provinceName +
          '/' +
          this.formData.pickupPoint.cityName +
          '/' +
          this.formData.pickupPoint.districtName
        return temp
      },
      set(val) {
        console.log(val)
      },
    },
    showReceivePoint: {
      get() {
        let temp =
          this.formData.receivingPoint.provinceName +
          '/' +
          this.formData.receivingPoint.cityName +
          '/' +
          this.formData.receivingPoint.districtName
        return temp
      },
      set(val) {
        console.log(val)
      },
    },
    totAmount: {
      get() {
        return add(this.orderFreight || 0, this.orderFee || 0)
      },
      set(val) {
        this.formData.totalAmount = val
      },
    },
  },
  methods: {
    load() {
      this.incomeData = this.formData.income
      if (this.incomeData) {
        this.orderFreight = this.incomeData.orderFreight
        this.orderFee = this.incomeData.orderFee
        this.basePrice = this.incomeData.basePrice
      } else {
        this.incomeData = {}
      }
      if (this.incomeData.orderFeeDetail) {
        this.data = JSON.parse(this.incomeData.orderFeeDetail)
      }
      this.getContract()
    },
    getContract() {
      this.loading = true
      this.listContractData = []
      this.$api
        .contractCustomerMatchOrderListApi(this.formData)
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    showFeeDetail(row) {
      if (!row.feeList) {
        return
      }
      let feeList = row.feeList
      let content = ''
      feeList.forEach((item) => {
        let feeNameText = item.feeNameText
        let basePrice = item.basePrice
        content +=
          '<strong>' + feeNameText + '：<i>' + basePrice + '</i></strong><br/>'
      })
      this.$alert(content, '费用明细', {
        dangerouslyUseHTMLString: true,
      })
    },
    choiceClose() {
      this.$emit('choiceClose')
    },
    async choiceOk() {
      // let contractData = this.$refs.table.getRadioRecord()
      // if (!contractData) {
      //   this.$alert('请点击选择需要使用的合同', '提示信息', {})
      //   return
      // }
      const validResult = await this.$refs.expenseDetails.validEvent()
      if (!validResult) return
      const data = this.$refs.expenseDetails.getTableData()
      if (data) {
        this.incomeData.orderFeeDetail = JSON.stringify(data)
      }
      this.incomeData.orderCode = this.formData.orderCode
      this.incomeData.custCode = this.formData.custCode
      this.incomeData.basePrice = this.basePrice
      this.incomeData.orderFreight = this.orderFreight
      this.incomeData.orderFee = this.orderFee
      this.incomeData.totalAmount = this.totAmount

      this.fullScreenLoading = true
      this.listContractData = []
      this.$api
        .financeUpdateIncomeApi(this.incomeData)
        .then(() => {
          this.fullScreenLoading = false
          this.$emit('choiceOk')
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    radioChangeEvent({ newValue, $rowIndex }) {
      if (!this.formData.income) this.formData.income = {}
      if (!this.formData.income.contractCode) {
        this.assignment(newValue, $rowIndex)
        return
      }
      let msg = '重新选择合同将会替换掉现在的费用明细，是否确认替换？'
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.assignment(newValue, $rowIndex)
        })
        .catch(() => {
          this.$refs.table.clearRadioRow()
          this.$refs.table.setRadioRow(this.tableData[this.oldTableDataIndex])
        })
    },
    assignment(newValue, rowIndex) {
      this.oldTableDataIndex = rowIndex
      if (newValue) {
        this.incomeData = newValue
        this.orderFreight = this.incomeData.contractFreight
        this.formData.income.contractCode = newValue.contractCode
        let { feeList } = newValue
        if (!feeList) {
          this.orderFee = 0
          feeList = []
        } else {
          this.orderFee = feeList
            .map((fee) => fee.basePrice || 0)
            .reduce((res, next) => add(res, next))
        }
        this.data = feeList.map((row) => {
          return {
            basePrice: row.basePrice,
            feeNameText: row.feeNameText,
            feeName: row.feeName,
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 16px;
  font-weight: 500;
  color: #606266;
}
.item-title {
  width: 70px;
  font-size: 14px;
  color: #999999;
}
.item-text {
  width: 80px;
  font-size: 14px;
  color: #333333;
}
</style>
